export default __webpack_public_path__ + "static/media/polygon_blue.9cc8af5e.svg";